export function deepMerge<T>(target: T, source: unknown): T {
  if (!isObject(target) || !isObject(source)) {
    return (source === undefined ? target : source) as T;
  }

  const output: Record<string, unknown> = { ...target };

  Object.entries(source).forEach(([key, sourceValue]) => {
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;

    const targetValue = target[key];
    output[key] =
      isObject(sourceValue) && isObject(targetValue)
        ? deepMerge(targetValue, sourceValue)
        : sourceValue;
  });

  return output as T;
}

function isObject(item: unknown): item is Record<string, unknown> {
  return item !== null && typeof item === 'object' && !Array.isArray(item);
}
